require.register("app/product/show/InfoTab", function(exports, require, module){
  $0
  
});

